exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".giph {\n  display: inline-block;\n  float: left;\n  margin: 15px;\n  border-radius: 6px;\n  background-clip: border-box;\n  overflow: hidden;\n}\n.giph img {\n  display: block;\n}\n.giph.preload {\n  min-width: 200px;\n  min-height: 180px;\n  background-image: url(" + require("../../../../assets/images/cage.png") + ");\n  background-position: center center;\n}\n.giph.preload img {\n  opacity: 0.2;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./client/app/components/common/giph/giph.less
 ** module id = 70
 ** module chunks = 0
 **/